import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { enumList } from 'app/modules/core/constants/core.constants';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, forkJoin, map } from 'rxjs';

export interface EnumsDTO<T> {
  [key: string]: T[];
}

export interface EnumDTO {
  key: string | number;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class EnumeratorsService {
  private _httpClient: HttpClient = inject(HttpClient);

  private enums: EnumsDTO<EnumDTO> = null;
  enumSubject: BehaviorSubject<EnumsDTO<EnumDTO>> = new BehaviorSubject(null);

  getAllEnumerators(): Observable<any> {
    const enums = Object.values(enumList);

    return forkJoin(
      enums.map(enumName =>
        forkJoin({ [enumName]: this._httpClient.get<EnumDTO[]>(`${environment.baseApiUrl}/enumerators/${enumName}`) })
      )
    ).pipe(
      map((res: EnumsDTO<EnumDTO>[]) => {
        res.forEach(val => {
          this.enums = { ...this.enums, ...val };
        });

        this.enumSubject.next(this.enums);
      })
    );
  }

  getEnum(name: string) {
    return this.enums[name] ? this.enums[name] : null;
  }
}
